<template>
  <div id="navbar-main" class="nav-phone-black">
    <Modalsignup v-if="showModal" @close="setUser"></Modalsignup>
    <Modallogin v-if="showModalLogin" @close="setUser"></Modallogin>
    <div
      class="top-bar text-center"
      v-if="!hideTopBar && showTopbar"
    >
      <i class="fa-solid fa-gift" style="margin-right: 5px;"></i>
      <span @click="showModal = true" style="text-align: center;" v-html="promotionMessage"></span>
      <PageTranslator></PageTranslator>
    </div>

    <div id="nav-phone" v-if="shownavphone || isReservationHotelPage || showBurgerMenuBar">
      <div class="nav-phone" :class="[hideTopBarOnScroll && (isReservationHotelPage || showBurgerMenuBar) ? 'nav-phone-hidden' : '', hideTopBarOnScroll ? 'nav-without-top' : '']"  v-if="isReservationHotelPage || showBurgerMenuBar">
        <!-- Logo and Burger Menu for Reservation Hotel Page and Special Pages -->
        <div class="nav-phone-left">
          <a href="/" class="logo" v-if="!showBanner">
            <img src="../../images/Logo hortense.svg" v-set-alt>
          </a>
          <button v-if="showBackButton" class="back-button-nav" @click="goBack" aria-label="Go back">
            <i class="fas fa-arrow-left"></i>
          </button>
        </div>
        <div style="z-index:9999999;position:relative">
          <!-- Placeholder for search button if needed -->
        </div>
        <BurgerTwo :user="user" @menuOpened="hideTopBarBlack()" @menuClosed="showTopbarBlack()" @showSignupModal="showModal = true" @showLoginModal="showModalLogin = true"></BurgerTwo>
      </div>
      <div class="nav-phone" v-else>
        <!-- Original Search Layout -->
        <div class="search-wrapper">
          <div class="search-container" ref="searchContainer">
            <div class="d-flex flex-column w-100">
              <input
                type="text"
                class="search-input"
                v-model="search"
                @focus="showSuggestions = true"
                :placeholder="fetchPlaceholderText()"
              />
              <div class="date-range" v-if="dateRangeExist">
                <div class="date-range-text raleway-reg-p12">
                  <span class="date-range-text pl-0">Du {{ startDateParam }} au {{ endDateParam }}</span>
                </div>
              </div>
            </div>
            <FullScreenSearch v-if="showSuggestions" @close="showSuggestions = false" />
            <div class="icons-container">
            <div class="search-icon-container mr-5">
              <SearchbtnPhone v-if="!showBanner" @show="showSuggestions = true"></SearchbtnPhone>
            </div>
            <div>
              <BurgerTwo :user="user" @menuOpened="hideTopBarBlack()" @menuClosed="showTopbarBlack()" @showSignupModal="showModal = true" @showLoginModal="showModalLogin = true"></BurgerTwo>
            </div>

            <div v-if="suggestions.length && showSuggestions" class="suggestions-dropdown">
              <div
                v-for="suggestion in suggestions"
                :key="suggestion.id"
                class="suggestion-card"
                @click="goToAccommodation(suggestion.slug)"
              >
                {{ suggestion.name }}
              </div>
            </div>
          </div>
          </div>
        </div>
        <div class="search-banner-container" v-if="showBanner">
          <SearchbannerPhone @close="showBanner = false"></SearchbannerPhone>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import fetcher from 'packs/shared/api.js';
import Modalsignup from 'components/modals/Modalsignup.vue';
import SearchbtnPhone from 'components/btns/SearchbtnPhone.vue';
import SearchbannerPhone from 'components/btns/SearchbannerPhone.vue';
import BurgerTwo from "../menus/BurgerTwo.vue";
import FullScreenSearch from './FullScreenSearch.vue';
import _ from 'lodash';
import PageTranslator from 'components/shared/PageTranslator.vue';
import Modallogin from 'components/modals/Modallogin.vue';

export default {
  name: 'nav-phone',
  props: ["user", "shownavphone", "hidesearchbaronphone", "showBurgerMenuBar", "showBackButton"],
  components: {
    BurgerTwo,
    Modalsignup,
    SearchbannerPhone,
    SearchbtnPhone,
    FullScreenSearch,
    PageTranslator,
    Modallogin
  },
  data() {
    return {
      search: "",
      showModal: false,
      showModalLogin: false,
      showBanner: false,
      promotionMessage: "-10% sur votre 1er séjour",
      suggestions: {
        lodgings: [],
        departments: [],
        regions: [],
        cities: [],
        zones: [],
        territoires: []
      },
      showSuggestions: false,
      showTopbar: true,
      hideTopBarOnScroll: false,
      lastScrollPosition: 0,
      userLevel: null,
    };
  },
  mounted() {
    this.updatePromotionMessage();
    this.setUserLevel();
    this.$root.$on('openModal', _ => {
      this.showModal = true;
    });
    document.addEventListener('click', this.handleClickOutside);
    
    // Add scroll listener only for reservation hotel page
    if (this.isReservationHotelPage || this.showBurgerMenuBar) {
      window.addEventListener('scroll', this.handleScroll);
    }
    
    // Create debounced version of the API call
    this.debouncedFetchSuggestions = _.debounce(async () => {
      try {
        const response = await fetcher.get(`/lodgings/search_suggestions?query=${this.search}&geo=48.8575,2.3514`);
        this.suggestions = response.data;
      } catch (error) {
        console.error("Error fetching search suggestions", error);
      }
    }, 500);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
    window.removeEventListener('scroll', this.handleScroll);
    // Cancel any pending debounced calls
    if (this.debouncedFetchSuggestions) {
      this.debouncedFetchSuggestions.cancel();
    }
  },
  methods: {
    handleScroll() {
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      
      // If scrolling down and past threshold (50px)
      if (currentScrollPosition > 50 && currentScrollPosition > this.lastScrollPosition) {
        this.hideTopBarOnScroll = true;
      }
      // If scrolling up or at the top
      else if (currentScrollPosition < this.lastScrollPosition || currentScrollPosition <= 50) {
        this.hideTopBarOnScroll = false;
      }
      
      this.lastScrollPosition = currentScrollPosition;
    },
    setUser(user){
        this.user = user;
        this.showModal = false;
        this.showModalLogin = false;
      },
    fetchSuggestions() {
      if (this.search.length < 3) {
        this.suggestions = { lodgings: [], departments: [], regions: [], cities: [], zones: [], territoires: [] };
        return;
      }
      // Call the debounced function
      this.debouncedFetchSuggestions();
    },
    goToAccommodation(id) {
      window.open(`/reservation-hotel/${id}`, '_blank');
    },
    goToDestination(slug) {
      window.open(`/destination/${slug}`, '_blank');
    },
    goToDestinationTwo(id){
      window.open(`/reservation-hotel?zone=${id}`, '_blank');
    },
    goToDestinationThree(id){
      window.open(`/reservation-hotel?territoire=${id}`, '_blank');
    },
    handleClickOutside(event) {
    if (this.$refs.searchContainer && !this.$refs.searchContainer.contains(event.target)) {
      this.showSuggestions = false;
    }
  },
    showSearchBanner() {
      this.showBanner = true;
    },
    async updatePromotionMessage() {
      const pathParts = window.location.pathname.split('/');

      if (pathParts[1] === 'reservation-hotel' && pathParts[2]) {
        const slug = pathParts[2];
        try {
          const response = await fetcher.get(`/lodging/${slug}/banner_message`);
          const msg = response?.data?.message;
          if (msg && msg.trim() !== '') {
            this.promotionMessage = msg;
            return;
          }
        } catch (e) {
          console.error("Error fetching banner message:", e.message);
        }
      }
      const path = window.location.pathname;
      const urlParams = new URLSearchParams(window.location.search);
      const base = urlParams.get('base');
      // Check if user has loyalty status and has made a reservation
      if (this.user && this.userLevel) {
        this.promotionMessage = this.getLoyaltyMessage();
      } else {
        this.promotionMessage = '<span>Rejoignez le <a @click="showModal = true" style="text-decoration: underline; cursor: pointer; color: white;">Club Hortense</a> et profitez de -10% sur votre 1er séjour</span>';
      }
    },
    getLoyaltyMessage() {
      const messages = {
        'Membre': 'Cumulez des points fidélité et profitez de privilèges exclusifs lors de votre prochain séjour.',
        'Green Trotter': 'Grâce à votre statut Green Trotter, vous bénéficiez de 1 privilège exclusif lors de votre prochain séjour.',
        'Green Trotter Plus': 'Grâce à votre statut Green Trotter Plus, vous bénéficiez de 2 privilèges exclusifs lors de votre prochain séjour.',
        'Green Trotter Premium': 'Grâce à votre statut Green Trotter Premium, vous bénéficiez de 3 privilèges exclusifs lors de votre prochain séjour.',
        'Green Trotter Infinite': 'Grâce à votre statut Green Trotter Infinite, vous bénéficiez de 4 privilèges exclusifs lors de votre prochain séjour.'
      };
      return messages[this.userLevel] || '<span>Rejoignez le <a @click="showModal = true" style="text-decoration: underline; cursor: pointer; color: white;">Club Hortense</a> et profitez de -10% sur votre 1er séjour</span>';
    },
    async setUserLevel() {
      try {
        if (this.user) {
          const res = await fetcher.get('/loyalty_status/' + this.user.id);
          if (res.data && res.data.reservations && res.data.reservations.length > 0) {
            // Filter reservations to only include confirmed ones
            const confirmedReservations = res.data.reservations.filter(
              reservation => reservation.confirm === true && reservation.cancel !== true
            );
            if (confirmedReservations.length > 0 && res.data.loyalty_status) {
              this.userLevel = res.data.loyalty_status;
              this.updatePromotionMessage();
            }
          }
        }
      } catch (e) {
        console.error('Error fetching user level:', e.message);
      }
    },
    fetchPlaceholderText() {
      const url = new URL(window.location.href);
      const path = url.pathname;
      const searchParam = url.searchParams.get('search');

      // If search param exists, use it
      if (searchParam && searchParam.trim() !== '') {
        return searchParam;
      }

      // Check reservationState localStorage key
      const reservationState = localStorage.getItem('reservationState');
      if (reservationState) {
        try {
          const hotelData = JSON.parse(reservationState);
          if (hotelData.search && hotelData.search.trim() !== '') {
            return hotelData.search;
          }
        } catch (e) {
          console.error('Error parsing reservationState from localStorage:', e);
        }
      }

      return 'Où partez vous ?';
    },
    hideTopBarBlack() {
      this.showTopbar = false;
    },
    showTopbarBlack() {
      this.showTopbar = true;
    },
    goBack() {
      window.history.back();
    }
  },
  computed: {
      hideTopBar() {
        return window.location.pathname.includes('/seminaire-eco-responsable') ||
               window.location.pathname.includes('/seminars/locations') ||
               this.showSuggestions;
      },
      isReservationHotelPage() {
        const pathParts = window.location.pathname.split('/');
        return pathParts[1] === 'reservation-hotel' && pathParts[2];
      },
      startDateParam() {
        // First try to get from localStorage
        const reservationState = localStorage.getItem('reservationState');
        if (reservationState) {
          try {
            const state = JSON.parse(reservationState);
            if (state.koediaFrom) {
              return state.koediaFrom.split('-').reverse().join('/');
            }
          } catch (e) {
            console.error('Error parsing reservationState from localStorage:', e);
          }
        }
        // Fallback to URL parameters
        const url = new URL(window.location.href);
        return url.searchParams.get('start_date')?.split('-')?.reverse()?.join('/');
      },
      endDateParam() {
        // First try to get from localStorage
        const reservationState = localStorage.getItem('reservationState');
        if (reservationState) {
          try {
            const state = JSON.parse(reservationState);
            if (state.koediaTo) {
              return state.koediaTo.split('-').reverse().join('/');
            }
          } catch (e) {
            console.error('Error parsing reservationState from localStorage:', e);
          }
        }
        // Fallback to URL parameters
        const url = new URL(window.location.href);
        return url.searchParams.get('end_date')?.split('-')?.reverse()?.join('/');
      },
      dateRangeExist() {
        return (this.startDateParam && this.startDateParam != 'null' && this.startDateParam != 'undefined')  && (this.endDateParam && this.endDateParam != 'null' && this.endDateParam != 'undefined');
      }
  },
}
</script>

<style scoped lang="scss">
#navbar-main {
  display: flex;
  flex-direction: column;

  .top-bar {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 50px;
    font-size: 14px;
    color: white;
    background: #1c1c1c;
    position: fixed;
    top: 0;
    z-index: 102;
    padding: 5px;
    transition: transform 0.3s ease-in-out;
  }

  .nav-phone {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 10px;
    position: fixed; /* Make it fixed */
    top: 17px; /* Stick it to the top */
    left: 0; /* Full width */
    right: 0; /* Full width */
    z-index: 1000; /* Ensure it appears on top */
    background-color: white; /* Background color to prevent overlap issues */
  }

  .nav-phone-left {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .back-button-nav {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 33px;
    height: 33px;
    border-radius: 8.25px;
    background-color: #BFBFBF;
    border: none;
    cursor: pointer;
    padding: 0;
    color: #000;
    font-size: 16px;
    transition: background-color 0.2s ease;

    &:hover {
      background-color: #a0a0a0;
    }

    &:active {
      background-color: #909090;
    }
  }

  .search-wrapper {
    position: relative;
    width: 100%;
  }

  .search-container {
    position: relative;
    display: flex;
    align-items: center;
    background: #CFE5DC;
    border-radius: 21px;
    padding: 5px 10px;
    max-width: 600px;
    margin: 0 auto;
  }

  .search-input {
    border: none;
    background-color: transparent;
    outline: none;
    flex: 1;
    padding: 5px;
    padding-bottom: 0;
  }

  .date-range-text {
    padding-left: 5px;
  }

  .search-input::placeholder {
    color: #000; /* Adjust placeholder text color if needed */
  }

  .icons-container {
    display: flex;
    align-items: center;
  }

  .search-icon-container {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #CFE5DC; /* Same background color */
    border-radius: 50%; /* Make it round */
    padding: 5px; /* Adjust padding for size */
    margin-left: 5px; /* Adjust margin for spacing */
    margin-right: 15px;
  }

  .burger-icon-container {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #CFE5DC; /* Same background color */
    border-radius: 50%; /* Make it round */
    padding: 5px; /* Adjust padding for size */
    margin-left: 5px; /* Adjust margin for spacing */
  }

  .search-banner-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1000; /* Ensure it appears on top */
    background-color: #fff; /* Adjust as needed */
  }
}
.suggestions-dropdown {
  position: absolute;
  top: 100%; 
  left: 0;
  width: 100%;
  background: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  margin-top: 5px;
  overflow-y: auto;
  z-index: 1000;
  font-family: Raleway;
  max-height: 250px;
  overflow-y: auto;
}

.suggestion-card {
  padding: 12px;
  border-bottom: 1px solid #ddd;
  cursor: pointer;
  transition: background 0.2s;
  font-family: Raleway;
  text-transform: capitalize; 
  background-color: #E6E1DB;

}

.suggestion-card:hover {
  background: #f5f5f5;
}

.search-container {
  position: relative;
  width: 100%;
}
.suggestion-header {
  padding: 8px;
  font-weight: bold;
  background-color: #f5f5f5;
  border-bottom: 1px solid #ddd;
  font-family: Raleway;
  text-transform: uppercase; 
}

.nav-without-top {
   top: 0 !important;
   margin-top: unset !important;
 }

 .nav-phone-hidden {
   transform: translateY(-100%);
 }
</style>
